const app = (state) => state.app;
const allowBetaFeatures = (state) => state.app.authenticatedUser.betaFeatures;
const globalMessages = (state) => state.app.notifications.globalMessages;
const siteUpdates = (state) => state.app.notifications.organisationMessages.siteUpdates;
const pluginUpdates = (state) => state.app.notifications.organisationMessages.pluginUpdates;
const themeUpdates = (state) => state.app.notifications.organisationMessages.themeUpdates;
const siteUpdateStats = (state) => state.app.notifications.organisationMessages.stats;
const notificationSidebar = (state) => state.app.notificationSidebar;

export {
  app,
  notificationSidebar,
  globalMessages,
  siteUpdates,
  pluginUpdates,
  themeUpdates,
  siteUpdateStats,
  allowBetaFeatures,
};
